<template>
    <div class="product">
        <div class="product-hall-banner"></div>
        <div class="index-main">
            <div class="main-support">
                <div class="container">
                    <h4 class="support-title">PROFESSIONAL AND COMPREHENSIVE TECHNICAL SUPPORT</h4>
                    <h5 class="support-slogan">我们能为你提供的价值</h5>
                    <div class="suppport-arrow-down">
                        <img class="support-arrow-img slide-down" src="../../assets/img/arrow-down-black.png" alt="我们能为你提供的价值">
                    </div>
                    <div class="main-support-info">
                        软件、硬件均以平台方式开发而成<br>
                        全站采用以太网方式相互交换数据<br>
                        对实现双主机冗余、历史数据库冗余配置，使系统具有高可靠性<br>
                        数据处理能力强，响应速度快、稳定<br>
                        系统维护能力强
                    </div>
                </div>
            </div>
        </div>

        <div class="container product-hall-img1 product-hall-img"></div>
        <div class="container product-hall-img2 product-hall-img">
            <div class="content">
                <h2>产品优势</h2>
                通过“开放的数据库联接(ODBC)”与标准数据库(SQL SERVER,ORACLE,SYBASE,MYSQL等)联接，可与MIS系统交换数据。<br>
                支持标准MODBUS TCP、TCP/IP等协议，可与南大傲拓、施耐德、西门子、GE、AB等多个公司PLC产品进行通讯。
            </div>
        </div>
        <div class="container product-hall-img3 product-hall-img">

        </div>
        <div class="index-main">
            <div class="main-support">
                <div class="container">
                    <h4 class="support-title">Professional and comprehensive technical support </h4>
                    <h5 class="support-slogan">典型成功案例</h5>
                    <div class="suppport-arrow-down">
                        <img class="support-arrow-img slide-down" src="../../assets/img/arrow-down-black.png" alt="典型成功案例">
                    </div>
                    <div class="container" style="margin-top: 50px;">
                        <img src="../../assets/img/product/pro4-img4.jpg" alt>
                    </div>
                </div>
            </div>
        </div>


    </div>
    
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
}

.product-hall-banner {
    width: 100%;
    height: 530px;
    background: url(../../assets/img/product/pro-banner4.jpg) center;
}

main {
    display: block;
}

section {
    display: block;
}

h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
}

h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

h5 {
    display: block;
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.index-main .main-support {
    width: 100%;
    // height: 551px;
    color: #333;
    text-align: center;
    background: #fff;
    border-top: 1px solid #ffffff;
    padding-bottom: 40px;

    .support-title {
        font-size: 28px;
        font-weight: 200;
        font-family: "Ping Fang";
        margin: 70px 0 35px 0;
        text-transform: uppercase;
    }

    .support-slogan {
        font-size: 22px;
        font-weight: 700;
    }

    .support-arrow-down {
        opacity: .4;
        margin-top: 20px;
    }
    
    .main-support-info {
        margin-top: 65px;
        font-size: 16px;
        text-align: center;
        line-height: 28px;
    }
}

.product-hall-img {
    position: relative;

    .content {
        position: absolute;
        text-align: left;
        color: #666;
        font-size: 14px;
        line-height: 22px;
        max-width: 380px;
        margin-bottom: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        h2 {color: #333;}
    }
}

.product-hall-img1 {
    width: 100%;
    height: 500px;
    background: url(../../assets/img/product/pro4-img1.jpg) center;
    text-align: center;
    color: #fff;
}

.product-hall-img2 {
    width: 100%;
    height: 500px;
    background: url(../../assets/img/product/pro4-img2.jpg) center;
    text-align: center;

    .content {
        right: 50px;
        top: 150px;
    }
}

.product-hall-img3 {
    width: 100%;
    height: 520px;
    background: url(../../assets/img/product/pro4-img3.jpg) center;
    text-align: center;
    color: #fff;
}
 
.section {width: 100%;}
.container {
    max-width: 1000px;
    min-width: 1000px;
    margin: auto;
    width: 100%;
}


</style>